export default {
  login: () => {
    return '/login';
  },
  home: () => {
    return '/login';
  },
  manage: () => {
    return '/manage';
  },
  'manage-cancel-subscription': () => {
    return '/manage/cancel-subscription';
  },
  'manage-subscription': () => {
    return '/manage/subscription';
  },
  'manage-your-subscription': () => {
    return '/manage-your-subscription';
  },
  'request-password-reset': () => {
    return '/request-password-reset';
  },
  'our-cause': () => {
    return '/our-cause';
  },
  aboutUs: () => {
    return '/#about';
  },
  termsMuscleCharge: () => {
    return 'https://www.musclecharge.app/terms-of-service';
  },
  privacyMuscleCharge: () => {
    return 'https://www.musclecharge.app/privacy-policy';
  },
  blog: () => {
    return '/blog';
  },
  reviews: () => {
    return '/reviews';
  },
  contact: () => {
    return '/contact';
  },
  terms: () => {
    return 'https://tour.reverse.health/terms';
  },
  privacy: () => {
    return 'https://tour.reverse.health/privacy-policy';
  },
  downloadApp: () => {
    return '/download-app';
  },
  root: () => {
    return '/';
  },
  // Tapptitude URLs
  appLogin: () => {
    return '/manage/app/login';
  },
  appRequestPasswordReset: () => {
    return '/manage/app/request-password-reset';
  },
};
